import { Col } from "@amzn/stencil-react-components/layout";
import { Link, LinkTextDecorationOptions } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import { useGetItemsAux } from "hooks/catalogical-amznham";
import React, { useEffect, useState } from "react";
import { pageLimit } from "view/Page/CatalogicalSearchResults";

export interface FacetedFilterProps {
  title: string;
  type: string;
  filterName: string;
  addFacetFilter: (filter: { field: string; value: string }) => void;
}

const HardwareFacetedFilter = (props: FacetedFilterProps) => {
  const { data: items, isLoading, doGetItems } = useGetItemsAux();

  const [selectedFacet, setSelectedFacet] = useState<string>("");

  const handleFacetClick = (facetValue: string) => {
    setSelectedFacet(facetValue);
    props.addFacetFilter({ field: props.filterName, value: facetValue.toLowerCase() });
  };

  const handleAllOptionsClick = () => {
    setSelectedFacet("");
    props.addFacetFilter({ field: props.filterName, value: "" });
  };

  const fetchData = async () => {
    await doGetItems({
      searchParams: {
        limit: pageLimit,
        offset: 0,
        sortBy: "name",
        sortDirection: "asc",

        // Get all options for the type
        filter: JSON.stringify({ type: props.type }),
      },
    });
  };

  // Load initial values
  useEffect(() => {
    if (!items) {
      fetchData();
    }
  }, []);

  const getFacetOptions = () =>
    (items ?? []).map((item) => (
      <Link
        data-testid="facet-option"
        textDecoration={LinkTextDecorationOptions.None}
        key={item.name}
        href="#"
        onClick={() => handleFacetClick(item.name)}
        color="neutral90"
        margin={["S300", 0, 0, 0]}
        padding={[0, 0, 0, "S500"]}
        fontWeight={selectedFacet === item.name ? "bold" : "regular"}
      >
        {item.name}
      </Link>
    ));

  return (
    <Col data-testid={"hardware-facet"} padding={[0, 0, "S700", 0]}>
      <Text color="neutral70" margin={["S300", 0, 0, "S500"]} data-cy={`facet-filter-title`}>
        {props.title}
      </Text>
      <Link
        textDecoration={LinkTextDecorationOptions.None}
        fontWeight={selectedFacet === "" ? "bold" : "regular"}
        href="#"
        color="neutral90"
        margin={["S300", 0, 0, 0]}
        padding={[0, 0, 0, "S500"]}
        onClick={handleAllOptionsClick}
      >
        {"All"}
      </Link>
      {!isLoading && getFacetOptions()}
    </Col>
  );
};

export default HardwareFacetedFilter;
